import Rules from './rules';
import FormRuleManager from "../FormRuleManager.model";

/**
 * @param {string|Node} elt_id
 */
class ImaiosFormValidator extends FormRuleManager {
    constructor(imaiosForm, rules = [], translations = {}) {
        super(imaiosForm, rules, translations);

        this.validateTag();


        this.getForm().querySelector('[type="submit"]').addEventListener('click', () => {
            this.refreshFeedback();
        })
    }


    getMessage(entry) {
        return (
            typeof entry === "string" &&
            entry.length > 0
        ) ?
            entry :
            this.translations[entry]
        ;
    }


    getRulesHandler() {
        return Rules;
    }

    validateTag() {
        const form = this.getForm();
        const form_id = this.getFormID();
        if (form === null) {
            throw `Unable to find #${form_id}`;
        }

        if (
            typeof form.tagName !== 'string' ||
            form.tagName.toLowerCase() !== 'form'
        ) {
            throw `The folling element must be a <form> : #${form_id}`;
        }
    }

    refreshFeedback() {
        Object.values(this.rules).forEach(rules => rules.refreshFeedback());
    }

    static create(elt_id, rules = [], translations= {})  {
        return new ImaiosFormValidator(elt_id, rules, translations);
    }

    static autoload() {
        document.addEventListener("DOMContentLoaded", () => {
            const hincludePartsUsingForm = document.querySelectorAll('[data-form-validation="true"]');
            Array.from(hincludePartsUsingForm).forEach(element => {
                element.addEventListener('hinclude', () => {
                    const formContact = element.querySelector('form');
                    const rules = ImaiosFormValidator.retrieveRules(formContact);

                    window.ImaiosFormValidator.create(
                        formContact,
                        rules,
                        window.imaios_form_validation.translations
                    );
                });
            });
        });
    }

    async check() {
        // const rules = Object.values(this.rules);
        // for (const rule of rules) {
        //     rule.clearValidity();
        // }
        //
        // for (const rule of rules){
        //     console.log('check rule :', rule.getRuleName());
        //     if(!await rule.check()){
        //         rule.refreshFeedback();
        //         const message = rule.getMessage();
        //         console.log(rule.getRuleName(), 'NON',message);
        //
        //
        //         return false;
        //     }
        //
        //
        //     console.log(rule.getRuleName(), 'OUI');
        // }
        // return true;
        const results = await Promise.all(Object.values(this.rules).map(rules => rules.check()));
        return results.every(isValid => isValid === true);
    }

    /**
     *
     * @param {HTMLFormElement} formElement
     * @returns {Record<string, string>[]}
     */
    static retrieveRules(formElement) {
        /** @type {Element[]} */
        const rulesElements = Array.from(formElement.querySelectorAll('[data-rule="validation"]'));
        return rulesElements.map(ruleElement => {
            /** @type {Record<string, string>} */
            const rule = {};
            Array
              .from(ruleElement.attributes)
              .filter(attribute => attribute.name.match(/data-*/) && attribute.name !== 'data-rule')
              .forEach(attribute => rule[attribute.name.split('data-')[1]] = attribute.value);

            return rule;
        });
    }
}

window.ImaiosFormValidator = ImaiosFormValidator;
export default ImaiosFormValidator;
